import React from 'react';
import { Table } from 'react-bootstrap';

const OnyxYt = props => {

    return (
        <div className="swingintopfwd">
            <br />
            <div className="container">
                <Table align="center" striped bordered >
                    <thead>
                        <tr>
                            <th><a href="https://www.youtube.com/user/onyxlynx" >DarkOnyx on YouTube</a></th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr>
                            <td>
                            <iframe title="Onyx YouTube" width="560" height="315" src="https://www.youtube.com/embed/Xc3tH_EbW-Y" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </div>
    )

}

export default OnyxYt;
